module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#listicle",
      toString: function () {
        return this.url;
      }
    }